module.exports = __webpack_public_path__ + "img/cielorrasos.2108e25e.gif";